import React, { useEffect, useState } from "react";
import "./FrameTool.scss";
import magenta from "../../assets/images/magenta.png";
import lime from "../../assets/images/lime.png";
import cyan from "../../assets/images/cyan.png";
import Button from "../Utils/Button";
import sparkle from "../../assets/images/Sparkle.png";
import diamond from "../../assets/images/diamond.png";
import rocket from "../../assets/images/rocket.png";
import monkey from "../../assets/images/monkey.png";
import { motion, useTransform, useViewportScroll } from "framer-motion";

function FrameTool() {
  const [delay, setdelay] = useState(0.66);
  useEffect(() => {
    if (window.innerWidth < 991) {
      setdelay(0);
    } else {
      setdelay(0.66);
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth < 991) {
        setdelay(0);
      } else {
        setdelay(0.66);
      }
    });
  });
  const badges = {
    hodldiacyan: "/models/hodldiacyan.glb",
    hodlroccyan: "/models/hodlroccyan.glb",
    hodlmoncyan: "/models/hodlmoncyan.glb",
    hodldiamagenta: "/models/hodldiamagenta.glb",
    hodlrocmagenta: "/models/hodlrocmagenta.glb",
    hodlmonmagenta: "/models/hodlmonmagenta.glb",
    hodldialime: "/models/hodldialime.glb",
    buidlroclime: "/models/buidlroclime.glb",
    buidlmonlime: "/models/buidlmonlime.glb",
    buidldiacyan: "/models/buidldiacyan.glb",
    buidlroccyan: "/models/buidlroccyan.glb",
    buidlmoncyan: "/models/buidlmoncyan.glb",
    buidldiamagenta: "/models/buidldiamagenta.glb",
    buidlrocmagenta: "/models/buidlrocmagenta.glb",
    buidlmonmagenta: "/models/buidlmonmagenta.glb",
  };
  const [style, setstyle] = useState("hodl");
  const [creed, setcreed] = useState("dia");
  const [aura, setaura] = useState("cyan");
  const { scrollYProgress } = useViewportScroll();
  const scale = useTransform(scrollYProgress, [0, delay], [0.5, 1]);
  const opacity = useTransform(scrollYProgress, [0, delay], [0, 1]);

  const [model, setmodel] = useState("/models/hodlmoncyan.glb");

  useEffect(() => {
    handleActiveModel();
  }, [creed, style, aura]);
  const handleActiveModel = () => {
    var name = "/models/" + style + creed + aura + ".glb";
    setmodel(name);
  };
  return (
    <section className="frametool" id="frametool">
      <div className="container">
        <motion.div className="row boxframe" style={{ scale, opacity }}>
          <div className="col-12 col-lg-6 frameEditor">
            <h3>Mint your NFT Badge </h3>
            <div className="option">
              <div className="name">Style</div>
              <div className="option__row">
                <div
                  className={style !== "hodl" ? "opt" : "opt optactive"}
                  onClick={() => setstyle("hodl")}
                >
                  {/* <img src={one} alt="HODL" /> */}
                  HODL
                </div>
                <div
                  className={style !== "buidl" ? "opt" : "opt optactive"}
                  onClick={() => setstyle("buidl")}
                >
                  {/* <img src={two} alt="BUIDL" /> */}
                  BUIDL
                </div>
              </div>
            </div>
            <div className="option">
              <div className="name">Creed</div>
              <div className="option__row">
                <div
                  className={creed !== "dia" ? "opt" : "opt optactive"}
                  onClick={() => setcreed("dia")}
                >
                  {/* <img src={one} alt="diamond" />{" "} */}
                  <img src={diamond} alt="" style={{ height: 22 }} />
                </div>
                <div
                  className={creed !== "roc" ? "opt" : "opt optactive"}
                  onClick={() => setcreed("roc")}
                >
                  {/* <img src={two} alt="rocket" />{" "} */}
                  <img src={rocket} alt="" style={{ height: 22 }} />
                </div>
                <div
                  className={creed !== "mon" ? "opt" : "opt optactive"}
                  onClick={() => setcreed("mon")}
                >
                  {/* <img src={three} alt="monkey" />{" "} */}
                  <img src={monkey} alt="" style={{ height: 22 }} />
                </div>
              </div>
            </div>

            <div className="option">
              <div className="name">Aura</div>
              <div className="option__row">
                <div
                  className={aura !== "cyan" ? "opt" : "opt optactive"}
                  onClick={() => setaura("cyan")}
                >
                  <img src={cyan} alt="cyan" /> Cyan
                </div>
                <div
                  className={aura !== "magenta" ? "opt" : "opt optactive"}
                  onClick={() => setaura("magenta")}
                >
                  <img src={magenta} alt="magenta" /> Magenta
                </div>
                <div
                  className={aura !== "lime" ? "opt" : "opt optactive"}
                  onClick={() => setaura("lime")}
                >
                  <img src={lime} alt="lime" /> Lime
                </div>
              </div>
            </div>
            <div className="pt-4 md-text-center">
              <Button text={"Make your IndiGG NFT Badge"} image={sparkle} />
            </div>
          </div>
          <div className="col-12 col-lg-6 previewPane" id="preview">
            {/* <img src={model} alt="" /> */}
            <model-viewer
              alt="Frame"
              src={model}
              ar
              ar-modes="webxr scene-viewer quick-look"
              seamless-poster
              shadow-intensity="1"
              camera-controls
            ></model-viewer>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default FrameTool;
